import React, { useState, useCallback } from 'react';
import { Form } from '@ant-design/compatible';
import Drawer from '../../../../../components/Drawer/Drawer';
import SelectForm from '../../../../../components/form/SelectForm';
import InputForm from '../../../../../components/form/InputForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import CountOfTotal from '../../../../../components/CountOfTotal';
import Button from '../../../../../components/Button';
import {
  MAXIMUM_NUMBER_OF_CS_MEMO_TEXT,
  ORDER_ITEM_CS_RECEPTION_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/orderConstants';
import { formRequiredRules } from '../../../../../lib/formRules';
import { REX_URL } from '../../../../../lib/rex';
import { asyncSimpleModal } from '../../../../../lib/common';

const OrderCsMemoDetailDrawer = (props) => {
  const { form, orderItemId, onClose, insertOrderItemCsMemoRequest, editOrderItemCsMemoRequest, isCreate } = props;
  const [csMemoInfo, setCsMemoInfo] = useState({
    orderItemCsId: props.orderItemCsId,
    receptionType: props.receptionType,
    linkUrl: props.linkUrl,
    memo: props.memo,
  });

  const saveCsMemo = useCallback(
    (data) => {
      const { orderItemCsId, receptionType, linkUrl, memo } = data;

      form.validateFields(async (err) => {
        if (err) return;

        if (isCreate) {
          const confirmResult = await asyncSimpleModal({
            type: 'confirm',
            title: 'CS 메모 등록 확인',
            message: '접수처, 메모 내용은 수정할 수 없습니다.\n' + '등록 하시겠습니까?',
          });

          if (confirmResult) {
            insertOrderItemCsMemoRequest({
              orderItemId,
              receptionType,
              linkUrl,
              memo,
            });

            /**
             *  정확한 원인은 모르겠지만
             *  컨펌모달 확인 버튼을 클릭한 경우 body 태그에 overflow : hidden 스타일 값이 붙어서 이를 제거 해야해서
             *  overflow: hidden 값이 생긴 이후에 제거 작업이 진행되어야 함
             */
            setTimeout(() => {
              document.body.setAttribute('style', '');
            }, 500);
          }
        } else {
          editOrderItemCsMemoRequest({
            orderItemId,
            orderItemCsId,
            linkUrl,
          });
        }

        onClose();
      });
    },
    [editOrderItemCsMemoRequest, form, insertOrderItemCsMemoRequest, isCreate, onClose, orderItemId],
  );

  return (
    <Drawer
      className="order-detail-cs-memo-drawer"
      title="CS 메모"
      visible={true}
      placement="bottom"
      mask={false}
      onClose={() => onClose()}
    >
      <div className="cs-memo-write-wrap">
        <div className="general-info">
          <SelectForm
            className="cs-memo-write-item"
            form={form}
            label="접수처"
            rules={[formRequiredRules(true, '접수처를 선택해주세요', false)]}
            initialValue={csMemoInfo.receptionType}
            list={ORDER_ITEM_CS_RECEPTION_TYPE_SELECT_LIST}
            onChange={(value) =>
              setCsMemoInfo({
                ...csMemoInfo,
                receptionType: value,
              })
            }
            disabled={!isCreate}
            name="receptionType"
          />

          <InputForm
            className="cs-memo-write-item"
            form={form}
            label="관련 url"
            rules={[{ pattern: REX_URL, message: '올바른 URL 을 입력하시기 바랍니다.' }]}
            initialValue={csMemoInfo.linkUrl}
            onChange={(value) =>
              setCsMemoInfo({
                ...csMemoInfo,
                linkUrl: value,
              })
            }
            size="large"
            name="linkUrl"
          />
        </div>

        <TextAreaForm
          className="cs-memo-write-item"
          form={form}
          label={
            <span>
              메모
              <CountOfTotal content={csMemoInfo.memo} maxCnt={MAXIMUM_NUMBER_OF_CS_MEMO_TEXT} />
            </span>
          }
          rules={[formRequiredRules(true, '메모를 작성해주세요', false)]}
          initialValue={csMemoInfo.memo}
          onChange={(value) =>
            setCsMemoInfo({
              ...csMemoInfo,
              memo: value,
            })
          }
          placeholder="어떠한 팀원도 고객에 대한 CS 의무에 대해서 면제될 수 없다 - Byrd Baggett"
          maxLength={MAXIMUM_NUMBER_OF_CS_MEMO_TEXT}
          autoSize={{ minRows: 4, maxRows: 50 }}
          disabled={!isCreate}
          name="memo"
        />
      </div>

      <div className="drawer-confirm-button-area">
        <Button text="취소" onClick={() => onClose()} />

        <Button
          color="primary"
          text="저장"
          onClick={() =>
            saveCsMemo({
              orderItemCsId: csMemoInfo.orderItemCsId,
              receptionType: csMemoInfo.receptionType,
              linkUrl: csMemoInfo.linkUrl,
              memo: csMemoInfo.memo,
            })
          }
        />
      </div>
    </Drawer>
  );
};

export default Form.create()(OrderCsMemoDetailDrawer);
